import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private loaded = false;
  private isLoading = false;
  private _loginState = new BehaviorSubject<boolean>(false);

  // Expose observable for components to subscribe to
  public loginStateChanged = this._loginState.asObservable();

  constructor() {
    // Initialize login state from localStorage on service creation
    this.initializeLoginState();

    // Listen for storage events (when localStorage changes in another tab)
    window.addEventListener('storage', () => {
      this.initializeLoginState();
    });
  }

  private initializeLoginState(): void {
    const customerId = localStorage.getItem('customerId');
    const isLoggedIn = !!(customerId && customerId !== 'undefined');
    this._loginState.next(isLoggedIn);
  }

  setLoginState(isLoggedIn: boolean): void {
    this._loginState.next(isLoggedIn);
    // No need to update localStorage here, as that should be done where the actual login/logout happens
  }

  getLoginState(): boolean {
    return this._loginState.value;
  }

  checkLoaded() {
    return this.loaded;
  }

  setLoaded(state: boolean) {
    this.loaded = state;
  }

  // ... any other existing methods
}

